/* ===========================================================================
   VJ-CORR-D175 — LA GALERIE DE LA FICHE SE LAISSE GLISSER
   6 septembre 2026
   ---------------------------------------------------------------------------
   Rachid : « dès qu'on débouche sur une fiche produit, on a les photos avec le
   petit carrousel juste en dessous des photos. »

   ─── L'INDICE DE BALAYAGE MENTAIT ──────────────────────────────────────────
   `theme.js:1565` monte la galerie principale avec `allowTouchMove: false` :
   sur téléphone, la grande photo ne bouge pas au doigt. Pendant ce temps,
   `vj-motion.js:459` pose sous elle « ↔ FAITES GLISSER » — l'indice auquel
   Rachid tient, et qui ici promettait un geste qui n'existait pas. Deux
   fichiers, chacun juste de son côté, et un mensonge à l'écran.

   On ne touche pas à `theme.js` : c'est un fichier de thème de 4 000 lignes,
   et une retouche s'y perdrait à la première mise à jour. Swiper expose
   `allowTouchMove` en écriture à chaud — on le rend, une fois l'instance
   montée.

   ─── ET LA GALERIE N'AVANCE PLUS TOUTE SEULE ───────────────────────────────
   `vj-motion.js` empile tout `.swiper` dont le nombre de vues dépasse
   `slidesPerView` dans une liste qu'il fait avancer d'un pas toutes les neuf
   secondes. La galerie produit a `slidesPerView: 1` et N photos : elle y
   entrait. Résultat, les photos d'une pièce changeaient toutes seules pendant
   qu'on lisait la description — et le défaut qu'on croit voir sur la photo 3
   n'y est plus quand on veut y revenir. La colonne de miniatures y entrait
   aussi dès la cinquième photo.

   La garde est posée DANS vj-motion.js, à la source, pas ici : c'est là qu'est
   la décision. Ce fichier ne fait que rendre le geste.

   Rollback : supprimer la ligne de layout/theme.liquid et ce fichier.
   =========================================================================== */
(function () {
  'use strict';

  function rendreLeGeste() {
    var galeries = document.querySelectorAll('.product-media-gallery');
    var reste = false;
    for (var i = 0; i < galeries.length; i++) {
      var el = galeries[i];
      if (el.dataset.vjGeste === '1') continue;
      var sw = el.swiper;
      if (!sw || !sw.params) {
        reste = true;
        continue;
      }
      el.dataset.vjGeste = '1';
      sw.params.allowTouchMove = true;
      sw.allowTouchMove = true;
      /* `simulateTouch` gouverne le glissement à la SOURIS. On le laisse à
         faux : sur ordinateur les miniatures sont juste dessous et un
         glissement à la souris sur une photo entre en concurrence avec la
         sélection de texte et avec PhotoSwipe, qui s'ouvre au clic. */
      if (sw.update) sw.update();

      brancherLesMiniatures(el, sw);
      appliquerLeMode(sw);
    }
    return reste;
  }

  /* ── D366 · SUR ORDINATEUR, LA GALERIE N'EST PLUS UN CARROUSEL ────────────
     Rachid, captures de fashionica à l'appui : « elle met la photo centrale en
     premier, et ensuite deux par deux, l'une à côté de l'autre ». Au-delà de
     992 px, vj-premium.css (bloc D366) range les vues en GRILLE : la première
     sur toute la largeur de la colonne, les suivantes par deux. Le Swiper du
     thème reste monté (le téléphone s'en sert, et une fenêtre qui passe sous
     992 doit le retrouver) : on le DÉSACTIVE simplement, pour que clavier et
     glissement ne fassent plus bouger une grille — et on le réactive sous 992.

     Deux mesures pour la mise en page, que le CSS ne sait pas prendre :
     · `--vj-vw` : la largeur UTILE de la fenêtre (`clientWidth`, barre de
       défilement exclue). `100vw` la compte sous Windows, et la colonne photo
       déborderait de 8,5 px à droite de la moitié ;
     · `--vj-info-h` : la hauteur de la colonne d'informations (1 589 px à
       1 440). Plus haute que la fenêtre, elle se pose par le BAS quand on
       descend (voir le bloc D366). Relevée à chaque changement de taille —
       un onglet ouvert l'allonge. */
  var BUREAU = window.matchMedia('(min-width: 992px)');
  var instances = [];

  function appliquerLeMode(sw) {
    if (sw && instances.indexOf(sw) === -1) instances.push(sw);
    var bureau = BUREAU.matches;
    for (var i = 0; i < instances.length; i++) {
      var s = instances[i];
      if (!s || s.destroyed) continue;
      if (bureau && s.enabled && typeof s.disable === 'function') s.disable();
      if (!bureau && !s.enabled && typeof s.enable === 'function') {
        s.enable();
        if (s.update) s.update();
      }
    }
    mesurer();
  }

  function mesurer() {
    document.documentElement.style.setProperty('--vj-vw', document.documentElement.clientWidth + 'px');
    var infos = document.querySelectorAll('.mainProduct .product__info-wrapper');
    for (var i = 0; i < infos.length; i++) {
      var hote = infos[i].closest('.mainProduct');
      if (hote) hote.style.setProperty('--vj-info-h', Math.ceil(infos[i].getBoundingClientRect().height) + 'px');
    }
  }

  var suiviInfos = false;
  function suivreLesInfos() {
    if (suiviInfos || typeof ResizeObserver !== 'function') return;
    var infos = document.querySelectorAll('.mainProduct .product__info-wrapper');
    if (!infos.length) return;
    suiviInfos = true;
    var ro = new ResizeObserver(function () { mesurer(); });
    for (var i = 0; i < infos.length; i++) ro.observe(infos[i]);
  }

  var attente = null;
  window.addEventListener('resize', function () {
    if (attente) window.cancelAnimationFrame(attente);
    attente = window.requestAnimationFrame(function () { appliquerLeMode(null); });
  });

  /* D341 posait ici une teinte tirée des bords de chaque photo ; retirée par
     D357 le même soir (traînées horizontales sur le sac, voir vj-premium.css). */

  /* ── L'ÉTAT ACTIF DE LA BANDE DE MINIATURES ───────────────────────────────
     En disposition horizontale, la bande n'est plus un Swiper (D175, voir
     snippets/wdt-product-medias.liquid). C'était Swiper qui posait
     `swiper-slide-thumb-active` : on le pose ici, et on fait en plus glisser
     la bande pour que la miniature courante reste visible — sur une pièce à
     huit photos, la sixième est hors champ. */

  function brancherLesMiniatures(galerie, sw) {
    var hote = galerie.closest('[data-main-gallery-id]') || document;
    var bande = hote.querySelector('[data-vj-miniatures]');
    if (!bande || bande.dataset.vjLiee === '1') return;
    bande.dataset.vjLiee = '1';

    var vignettes = bande.querySelectorAll('.thumbnail-slide');

    function suivre() {
      var actif = sw.slides && sw.slides[sw.activeIndex];
      var id = actif ? actif.getAttribute('data-media-id') : null;
      var courante = null;
      for (var i = 0; i < vignettes.length; i++) {
        var elle = vignettes[i].getAttribute('data-media-id') === id;
        vignettes[i].classList.toggle('swiper-slide-thumb-active', elle);
        vignettes[i].setAttribute('aria-current', elle ? 'true' : 'false');
        if (elle) courante = vignettes[i];
      }
      if (!courante) return;
      var piste = bande.querySelector('.vj-miniatures__piste') || bande;
      var b = courante.getBoundingClientRect();
      var p = piste.getBoundingClientRect();
      if (b.left < p.left || b.right > p.right) {
        piste.scrollTo({
          left: piste.scrollLeft + (b.left - p.left) - (p.width - b.width) / 2,
          behavior: 'smooth'
        });
      }
    }

    if (sw.on) sw.on('slideChange', suivre);
    suivre();
  }

  function veiller(essais) {
    if (!document.querySelector('.product-media-gallery')) return;
    mesurer();
    suivreLesInfos();
    if (rendreLeGeste() && essais > 0) {
      window.setTimeout(function () {
        veiller(essais - 1);
      }, 300);
    }
  }

  function demarrer() {
    /* Swiper est monté par theme.js sur DOMContentLoaded ; on repasse une
       dizaine de fois sur trois secondes plutôt que de parier sur l'ordre. */
    veiller(12);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);
})();
